module.exports = __webpack_public_path__ + "img/q_customer.8a6b3598.png";